import React from 'react';
import './FilledCheckbox.css';

const FilledCheckbox = ({ option, onClickAction, isChecked }) => {

// console.log(isChecked)
    return (
        <>
            <input className='custom-checkbox' type="checkbox" id={option.id} onChange={(e) => { onClickAction(e.target.id) }} defaultChecked={isChecked} />
            <label htmlFor={option.id}>{option.text}</label>

        </>

    )
}
export default FilledCheckbox
